
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[franchiseeSlug]/contact",
      function () {
        return require("private-next-pages/[franchiseeSlug]/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[franchiseeSlug]/contact"])
      });
    }
  